/**
 * @flow
 * @relayHash 6b7778dd3c99ef4640d3fef08f60e813
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateSfacExtensionPromptResponseInput = {|
  userId: string,
  browser: string,
  accepted: boolean,
  clientMutationId?: ?string,
|};
export type CreateSfacExtensionPromptResponseMutationVariables = {|
  input: CreateSfacExtensionPromptResponseInput
|};
export type CreateSfacExtensionPromptResponseMutationResponse = {|
  +createSfacExtensionPromptResponse: ?{|
    +user: ?{|
      +showSfacExtensionPrompt: boolean
    |}
  |}
|};
export type CreateSfacExtensionPromptResponseMutation = {|
  variables: CreateSfacExtensionPromptResponseMutationVariables,
  response: CreateSfacExtensionPromptResponseMutationResponse,
|};
*/


/*
mutation CreateSfacExtensionPromptResponseMutation(
  $input: CreateSfacExtensionPromptResponseInput!
) {
  createSfacExtensionPromptResponse(input: $input) {
    user {
      showSfacExtensionPrompt
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateSfacExtensionPromptResponseInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "showSfacExtensionPrompt",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateSfacExtensionPromptResponseMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createSfacExtensionPromptResponse",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateSfacExtensionPromptResponsePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateSfacExtensionPromptResponseMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createSfacExtensionPromptResponse",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateSfacExtensionPromptResponsePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateSfacExtensionPromptResponseMutation",
    "id": null,
    "text": "mutation CreateSfacExtensionPromptResponseMutation(\n  $input: CreateSfacExtensionPromptResponseInput!\n) {\n  createSfacExtensionPromptResponse(input: $input) {\n    user {\n      showSfacExtensionPrompt\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6e6f16843e0b9bfa476a15af7ad99958';
module.exports = node;
